import Location from '../../../ports-frontend/Location';
import { LogicContext } from '../types';

export const runGameFromDirectLink = (context: LogicContext) => async () => ({
  shouldRunTheGame:
    (await Location.get()).pathname !== context.gameToLaunch?.gameLaunchPath,
});
